import { NAV_BANNER_IS_VIEWED } from './types';

export const triggerNavBannerView = title => ({
  type: NAV_BANNER_IS_VIEWED,
  title,
});
